import React, { useState } from 'react'
import { api, ApiError } from '../../lib/api'
import { useOverlayA11y } from '../../hooks/useOverlayA11y'

export function AddPracticeModal({ onClose, onCreated }: { onClose: () => void; onCreated: () => void }) {
  const [name, setName] = useState('')
  const [location, setLocation] = useState('')
  const [timezone, setTimezone] = useState('America/Edmonton')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const modalRef = useOverlayA11y(onClose)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api('/practices', { method: 'POST', body: JSON.stringify({ name, location: location || null, timezone }) })
      onCreated()
      onClose()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not create practice.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="modal-bg" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" ref={modalRef} role="dialog" aria-modal="true" aria-label="Add practice" tabIndex={-1}>
        <h2>Add practice</h2>
        <form onSubmit={submit}>
          <div className="field"><label>Name</label><input className="inp" value={name} onChange={(e) => setName(e.target.value)} required /></div>
          <div className="field"><label>Location (optional)</label><input className="inp" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Calgary, AB" /></div>
          <div className="field"><label>Timezone</label><input className="inp" value={timezone} onChange={(e) => setTimezone(e.target.value)} /></div>
          {error && <div className="form-error">{error}</div>}
          <button className="btn full" disabled={busy}>{busy ? 'Saving…' : 'Add practice'}</button>
        </form>
      </div>
    </div>
  )
}
